var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"center"}},[_c('dv-border-box-13',[_c('CenterTopEarch')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }